import React from "react";
import { connect } from "react-redux";

import { TimeSelect } from "../../components/timeselect";

import { viewModes } from "../../../common/common";
import { IcChevrLeft, IcLocationSearch } from "../../../common/svg";

import { HOME } from "../../../../constant/routes";

const CSQuicklySearch = (props) => {
	const { address, timeCS } = props.csFinding.filter;
	const { viewMode, visible, isSelectTimeCS, onSelectTimeCSChange, toggleSelectTimeCS, wrapperCSSelect } = props;

	const toggleSelect = () => {
		toggleSelectTimeCS()
	}

	return (
		<div className={`finding-section ${viewMode === viewModes.LIST ? "fixed" : ""} ${visible ? "" : "scroll-top"}`}>
			<div className="m-container">
				<div className="finding-container">
					<a className="wrap-svg back" href={HOME}>
						<IcChevrLeft />
					</a>
					<div className="finding-info">
						<div className="input-form">
							<div className="wrap-svg">
								<IcLocationSearch />
							</div>
							<div className="here-autocomplete">
								<p className="address pointer">{address}</p>
							</div>
						</div>
						{/* <div className="search-option">
							<TimeSelect id={'tsCF'} timeCS={timeCS} isSelectTimeCS={isSelectTimeCS} wrapperCSSelect={wrapperCSSelect} toggleSelectTimeCS={toggleSelect} onSelectTimeCSChange={onSelectTimeCSChange} />
						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
};

function mapState(state) {
	return {
		csFinding: state.csFinding,
	};
}

export default connect(mapState)(CSQuicklySearch);
